import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useLocation, useNavigate } from "react-router-dom";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { useDispatch, useSelector, } from "react-redux";
import { setManagementName } from "../../../../redux/Admin/managementViewSlice";
import { resetsessionName } from "../../../../redux/Admin/sessionViewSlice";
import { deleteManagement } from "../../../../redux/Managment/mangmentSlice"; // Adjust path as needed
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import { selectUserData } from "../../../../redux/auth/authSelector";
import { ROLES } from "../../../../config/rolePermissions";
import DeleteModal from "../../../../common/Common/DeleteModal";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const EmployeeList = ({ sampleData, onEdit, loading, onDeleteSuccess, companyData, currentPage = 1, limit = 10 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const rawCompanyId = searchParams.get("companyId");

  const { deleteManagement: deleteState } = useSelector((state) => state.managements);

  const userData = useSelector(selectUserData);
  const userRole = userData?.role_name;
  const isActiveCompany = companyData?.hasOwnProperty('company_isActive') ? companyData?.company_isActive : userData?.company_isActive;
  
  // S No. calculation
  const startIndex = (currentPage - 1) * limit;

  const handleDeleteClick = (employee) => {
    console.log(employee?.company_employee_id, "employeeemployeeemployeeemployee");
    setSelectedEmployee(employee?.company_employee_id);
    setIsOpen(true);
  };
  const handleConfirmDelete = async () => {
    if (!selectedEmployee) return;

    try {
      const result = await dispatch(
        deleteManagement({
          company_employee_id: selectedEmployee,
          company_id: Number(rawCompanyId)
        })
      ).unwrap();

      // ✅ show message coming from API
      SweetAlertService.showSuccess({
        title: "Success!",
        message: result?.message || "Deleted successfully",
      });

      setIsOpen(false);
      setSelectedEmployee(null);

      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      SweetAlertService.showError({
        title: "Error!",
        message: error,
      });
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setSelectedEmployee(null);
  };

  return (
    <div className="border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr className="text-start">
            <Th className="text-start">S No.</Th>
            <Th className="text-start"> Name</Th>
            <Th className="text-start">Email Address</Th>
            <Th className="text-start">Mobile Number</Th>
            <Th className="text-start">Designation</Th>
            <Th className="text-start">Gender</Th>
            <Th>Action</Th>
          </Tr>
        </THead>
        <TBody>
          {loading ? (
            <Tr>
              <Td colSpan={7} className="text-center py-10">
                <ThreeDotBouncingLoader />
              </Td>
            </Tr>
          ) : sampleData?.length > 0 ? (
            sampleData.map((item, index) => (
              <Tr key={item.id} className="text-center">
                <Td className="text-start">
                  {String(startIndex + index + 1).padStart(2, "0")}
                </Td>
                <Td className="text-start">{item.user?.first_name + " " + item.user?.last_name}</Td>
                <Td className="text-start">{item.user?.email || "-- "}</Td>
                <Td className="text-start">{item.user?.mobile_number || "--"}</Td>
                <Td className="text-start">{item.designation || "--"}</Td>
                <Td className="text-start">{item.gender || "--"}</Td>

                <Td>
                  <div className="flex gap-1">
                    {/* View Button */}
                    <CommonIconButton
                      type="view"

                      onClick={() => {
                        // HR users expect to open the standalone management view
                        if (userRole === ROLES.HR || userRole === ROLES.COMPANYADMIN || userRole === ROLES.MANAGEMENT) {
                          // persist name immediately so breadcrumbs render instantly

                          const name = item.user?.first_name ? `${item.user.first_name} ${item.user.last_name || ''}`.trim() : item.user?.name || item.user?.full_name || '';
                          if (name) dispatch(setManagementName(name));
                          // clear any previously stored session name to avoid showing wrong session
                          dispatch(resetsessionName());
                          navigate(`/management/view?empId=${item.company_employee_id}`);
                        } else {
                          // Admins/others keep company context
                          const name = item.user?.first_name ? `${item.user.first_name} ${item.user.last_name || ''}`.trim() : item.user?.name || item.user?.full_name || '';
                          if (name) dispatch(setManagementName(name));
                          // clear any previously stored session name to avoid showing wrong session
                          dispatch(resetsessionName());
                          navigate(`/companies/companyview?companyId=${rawCompanyId}&tab=managementOverview&view=true&empId=${item.company_employee_id}`);
                        }
                      }}

                    />

                    {/* Edit Button */}
                    {isActiveCompany && <CommonIconButton
                      type="edit"
                      onClick={() => onEdit(item)} />
                    }

                    {
                      item.designation == "HR" ||
                        item.designation == "Company Admin" ? "" :
                        isActiveCompany && (
                          <CommonIconButton
                            type="delete" onClick={() => handleDeleteClick(item)} />
                        )
                    }

                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={7} className="text-center text-gray-500 py-6 text-sm">No matching records found</Td>
            </Tr>
          )}
        </TBody>
      </Table>

      <DeleteModal
        dialogOpen={isOpen}
        onDialogClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        loading={deleteState.loading}
      // title="Delete Management User"
      // message={`Are you sure you want to delete ${selectedEmployee?.user?.first_name} ${selectedEmployee?.user?.last_name}?`}
      />
    </div>
  );
};

export default EmployeeList;